/**
 * This factory must be separated out because the sitemap uses the apollo
 * client without the stateLink and breaks if it has an import chain to
 * LocalState (at a glance, because it's not configured to handle imports
 * from graphql files)
 */

import localState from '../../local-state'
import withUserSettingsQuery from '../../containers/with-user-settings/query.graphql'
import makeApolloClient from './index'

export default function makeApolloClientWithLocalState({ ...opts }) {
  const client = makeApolloClient({
    ...opts,
    clientOpts: {
      ...opts.clientOpts,
      typeDefs: localState.typeDefs,
      resolvers: localState.resolvers,
    },
  })

  client.cache.writeQuery({
    query: withUserSettingsQuery,
    data: localState.defaults,
  })

  return client
}
